import lib from './lib';
import type { IMakeConfigEntry } from './lib/fontawesome';

namespace kmIcon {
  export const flagIcons = lib.flagIcons;
  export const fontawesome = lib.fontawesome;
  export type iFontawesomeConfig = IMakeConfigEntry;
}

export default kmIcon;
